import React, { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';

import { TableGrid } from '@C/TableGrid';
import { LoanPartyList, DateRangeFilter } from '@C/Utils';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Party name',
    key: '',
  },
  {
    name: 'Amount given',
    key: '',
  },
  {
    name: 'Interest',
    key: '',
  },
  {
    name: 'Amount received',
    key: '',
  },
  {
    name: 'Interest',
    key: '',
  },
  {
    name: 'Total amount',
    key: '',
  },
  {
    name: 'Payment mode',
    key: '',
  },
  {
    name: 'Total outstanding',
    key: '',
  },
  {
    name: 'Notes',
    key: '',
  },
];

const LoanLedger = () => {
  const [state, setState] = useState({
    loanList: [],
    start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
    end_date: dayjs().format('YYYY-MM-DD'),
    party_name: '',
    limit: 20,
    offset: 1,
    count: 0,
    loading: false,
  });

  const limitInput = useRef();

  useEffect(() => {
    // Add your componentDidMount logic here
  }, []);

  // Helper to get max allowed days based on party filter
  const getMaxDays = () => (state.party_name ? 183 : 31); // 6 months or 31 days

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    let { start_date, end_date, party_name } = state;

    if (name === 'start_date') {
      start_date = value;

      end_date = party_name
        ? dayjs(value).add(6, 'months').format('YYYY-MM-DD')
        : dayjs(value).add(31, 'day').format('YYYY-MM-DD');
    } else if (name === 'end_date') {
      end_date = value;
      // If end_date is before start_date, set start_date to end_date

      if (dayjs(value).isBefore(dayjs(start_date))) {
        toast.error('To date cannot be before the from date.');
      }
    }

    setState({
      ...state,
      [name]: value,
      start_date,
      end_date,
    });
  };

  const submitForm = (e) => {
    e.preventDefault();

    // On submit, if no party selected, restrict to max 31 days
    if (!state.party_name) {
      const start = dayjs(state.start_date);
      const end = dayjs(state.end_date);
      const diffDays = end.diff(start, 'day');
      if (diffDays > 31) {
        setState({
          ...state,
          end_date: start.add(31, 'day').format('YYYY-MM-DD'),
        });
        return;
      }
    }
    // Add your filter logic here
  };

  return (
    <>
      <section className="widget full-width list-table">
        <header>
          <h3>Loan Ledger </h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>Date range:</label>
                <DateRangeFilter
                  value={[state.start_date, state.end_date]}
                  onChange={(dates) => {
                    setState((prevProps) => ({
                      ...prevProps,
                      start_date: dates[0],
                      end_date: dates[1],
                    }));
                  }}
                  limit={6}
                />
              </div>
              <div className="filter-group">
                <label>Loan party</label>
                <LoanPartyList
                  value={state.party_name}
                  onChange={(selectedParty) =>
                    setState({
                      ...state,
                      party_name: selectedParty.value || null,
                      // When party filter is removed, restrict date range to 31 days
                      ...(selectedParty.value
                        ? {}
                        : {
                            end_date: dayjs(state.start_date)
                              .add(31, 'day')
                              .format('YYYY-MM-DD'),
                          }),
                    })
                  }
                  name="party_name"
                  isClearable={true}
                  isSearchable={true}
                  defaultValue={1}
                />
              </div>
              <div className="filter-group reset-filter">
                <button
                  onClick={() => {
                    setState({
                      ...state,
                      start_date: dayjs()
                        .subtract(1, 'month')
                        .format('YYYY-MM-DD'),
                      end_date: dayjs().format('YYYY-MM-DD'),
                      party_name: '',
                    });
                  }}
                >
                  Reset filter
                </button>
              </div>
              <div className="filter-group">
                <button
                  className={`submit ${state.loading ? 'loading' : ''}`}
                  type="submit"
                  onClick={submitForm}
                  disabled={state.loading}
                >
                  Apply filter
                </button>
              </div>
            </div>
          </div>
          <main className="content-wrapper">
            <TableGrid
              col={col}
              row={state.loanList}
              count={state.count}
              hideActions={true}
            />
          </main>
          <div className="mini-summary">
            <ul>
              <li>
                <span> Total outstanding balance: </span>
                <span>{/* Add the value here */}</span>
              </li>
            </ul>
          </div>
        </main>
      </section>
    </>
  );
};

export { LoanLedger };
